import { Schema } from 'effect';
import { SchemaUtils } from '@listening/api-contract/schema-utils';
import { optionalCatching, optionalCatchingTo } from '@/lib/search-params';

/**
 * Search-param schemas for the CDN-cacheable routes — the query params a
 * cacheable route's SERVER render reads, declared in a leaf module so the
 * routes and the cache-key drift test can import them without dragging in
 * components or runtimes.
 *
 * Adding a param here (or a schema for a newly cacheable route) means
 * deciding whether it joins `CACHE_KEY_QUERY_PARAMS`
 * (`./cache-key-query-params`) — the drift test in
 * `test/unit/analytics/cache-key-query-params.test.ts` fails until the two
 * agree.
 */

/**
 * A 1-based page number. The router JSON-parses search values, so `?page=2`
 * arrives as a number; a non-canonical spelling such as `?page=02` arrives as
 * a string and is coerced, and junk is absorbed by the `optionalCatching*`
 * wrapper at each use site.
 */
const pageNumber = SchemaUtils.NumberOrNumberFromString.pipe(
  Schema.check(Schema.isInt()),
  Schema.check(Schema.isGreaterThanOrEqualTo(1)),
);

/** `/doc` + `/doc/$docId` (public doc list/detail, s-maxage=300). */
export const publicDocSearchSchema = Schema.Struct({
  search: optionalCatching(Schema.String),
  category: optionalCatching(Schema.String),
  page: optionalCatching(pageNumber),
  cursor: optionalCatching(Schema.String),
});

/** `/blog` index (s-maxage=3600). */
export const blogIndexSearchSchema = Schema.Struct({
  page: optionalCatchingTo(pageNumber, 1),
});
